(function() {
'use strict';

const TR = angular.module('TR');

TR.directive('slidePanel', function(broker) {
    return {
        restrict: 'E',
        replace: true,
        transclude: true,

        scope: {
            open: '=',
            hideEvent: '@'
        },

        template: '<div class="slide-panel" ng-transclude></div>',

        link(scope, el) {
            scope.show = true;

            const slidePanel = el;
            const overlay = $('<div class="modal-overlay" />').appendTo(document.body);

            let icon = document.querySelectorAll('.icon')[0];

            // subscribe to hide event
            if (scope.hideEvent != null) {
                broker.subscribe('slidePanel', scope.hideEvent, function() {
                    scope.shutInstantly();
                });

                scope.$on('$destroy', function() {
                    broker.unsubscribe('slidePanel', scope.hideEvent);
                });
            }

            scope.slideOpen = function() {
                slidePanel.show();

                //disable browser scroll bar
                $('body').css('overflow', 'hidden');

                overlay.fadeIn(300, 'swing', function() {
                    const domOverlay = overlay.get(0);
                    domOverlay.style.display = 'none';
                    overlay.one('click.slidePanel', function() {
                        scope.$apply(scope.open = false);
                    });
                    slidePanel.addClass('open');
                });

                icon.classList.add('icon-close');
                icon.classList.remove('icon-menu');
            };

            scope.slideShut = function() {
                slidePanel.removeClass('open');
                overlay.fadeOut(200, 'swing', function() {
                    overlay.hide(); //extra hide required to deal with when we close and are 'off screen'
                });
                // re-enable browser scroll bar
                $('body').css('overflow', '');

                icon.classList.add('icon-menu');
                icon.classList.remove('icon-close');

                let dropdowns = document.querySelectorAll('.dropdown');
                dropdowns[0].classList.remove('dropdown');
            };

            scope.shutInstantly = function() {
                // close panel instantly
                overlay.hide();

                slidePanel.hide();
                slidePanel.removeClass('open');

                // re-enable browser scroll bar
                $('body').css('overflow', '');

                stopWatch();
                scope.open = false;
                startWatch();

                icon.classList.add('icon-menu');
                icon.classList.remove('icon-close');
            };


            let canceller;
            function stopWatch() {
                if (canceller != null) {
                    canceller();
                }
            }

            function startWatch() {
                stopWatch();
                canceller = scope.$watch('open', function(v, o) {
                    if (v == null || v === o) { return; }
                    if (v) {
                        // open
                        scope.slideOpen();
                    } else {
                        // close
                        scope.slideShut();
                    }
                });
            }

            startWatch();
        }
    };
});
})();
